<div class="content-with-chat h-full">
  <div class="video-section" [class.has-gap]="!layoutService.isLayout(VideoLayout.SINGLE)">
    <div
      class="video-container"
      id="videoContainer"
      [ngClass]="containerAspectRatioClass()"
      [class.layout-single]="layoutService.isLayout(VideoLayout.SINGLE)"
      [class.layout-side-by-side]="layoutService.isLayout(VideoLayout.SIDE_BY_SIDE)"
      [class.layout-stacked]="layoutService.isLayout(VideoLayout.STACKED)"
      [class.layout-large-left]="layoutService.isLayout(VideoLayout.LARGE_LEFT)"
      [class.layout-large-right]="layoutService.isLayout(VideoLayout.LARGE_RIGHT)"
      [class.layout-grid-2x2]="layoutService.isLayout(VideoLayout.GRID_2X2)"
      [class.has-gap]="!layoutService.isLayout(VideoLayout.SINGLE)"
    >
      <!-- Main Video (always shown) -->
      <vb-lxp-video-slot
        #livestreamPlayerSlot
        class="aspect-video"
        [ngClass]="layoutService.isLayout(VideoLayout.GRID_2X2) ? 'mt-auto' : ''"
        id="mainVideo"
        [label]="'Main Feed'"
        [showBadge]="true"
        [time]="'3:42:18'"
        [isLive]="true"
        [progressPercent]="55"
        [volumePercent]="70"
        (playerClosed)="onPlayerClosed($event)"
      />

      @if (
        layoutService.isLayout(VideoLayout.SIDE_BY_SIDE) ||
        layoutService.isLayout(VideoLayout.STACKED)
      ) {
        <vb-lxp-video-slot
          #livestreamPlayerSlot
          class="aspect-video"
          [ngClass]="layoutService.isLayout(VideoLayout.GRID_2X2) ? 'h-full' : ''"
          [label]="'Onboard Camera'"
          [showBadge]="true"
          [time]="'3:42:18'"
          [isLive]="true"
          [src]="''"
          (playerClosed)="onPlayerClosed($event)"
        />
      }

      @if (
        !isMobile() &&
        (layoutService.isLayout(VideoLayout.LARGE_LEFT) ||
          layoutService.isLayout(VideoLayout.LARGE_RIGHT) ||
          layoutService.isLayout(VideoLayout.GRID_2X2))
      ) {
        <vb-lxp-video-slot
          #livestreamPlayerSlot
          class="aspect-video mt-auto"
          [label]="'Pit Lane'"
          [showBadge]="true"
          [time]="'3:42:18'"
          [isLive]="true"
          [src]="''"
          (playerClosed)="onPlayerClosed($event)"
        />
        <vb-lxp-video-slot
          #livestreamPlayerSlot
          class="aspect-video mb-auto"
          [label]="'Turn 1'"
          [showBadge]="true"
          [time]="'3:42:18'"
          [isLive]="true"
          [src]="''"
        />
      }

      @if (!isMobile() && layoutService.isLayout(VideoLayout.GRID_2X2)) {
        <vb-lxp-video-slot
          #livestreamPlayerSlot
          class="aspect-video"
          [ngClass]="layoutService.isLayout(VideoLayout.GRID_2X2) ? 'mb-auto' : ''"
          [label]="'Paddock'"
          [showBadge]="true"
          [time]="'3:42:18'"
          [isLive]="true"
          [src]="''"
          (playerClosed)="onPlayerClosed($event)"
        />
      }
    </div>

    <!-- Race Info Bar -->
    @if (raceStatus()) {
      <div class="race-info-bar">
        <div class="race-info-item">
          <span class="race-info-label">LAP</span>
          <span class="race-info-value lap-value">{{ raceStatus()?.elapsedLaps | json }}</span>
        </div>
        <div class="race-info-item">
          <span class="race-info-label">ELAPSED</span>
          <span class="race-info-value">{{ timeStatus()?.elapsedTime | timespan }}</span>
        </div>
        <div class="race-info-item">
          <span class="race-info-label">REMAINING</span>
          <span class="race-info-value">{{ timeStatus()?.remainingTime | timespan }}</span>
        </div>
        @if (!isMobile()) {
          <!--<div class="race-info-item">
          <span class="race-info-label">REMAINING</span>
          <span class="race-info-value">~28:00</span>
        </div>
        <div class="race-info-item">
          <span class="race-info-label">TRACK TEMP</span>
          <span class="race-info-value">42°C</span>
        </div>
        <div class="race-info-item">
          <span class="race-info-label">CONDITIONS</span>
          <span class="race-info-value conditions-value">
            <span class="conditions-icon">☀️</span> Dry
          </span>
        </div>-->
        }
      </div>
    }
  </div>

  <!-- Chat Panel -->
  <div class="panel-container">
    <vb-lxp-panel
      #timingPanel
      [panelKey]="'timing'"
      [defaultOpenState]="true"
      [panelClass]="'timing-panel'"
      [panelHeaderClass]="'timing-panel-header'"
      [panelBodyClass]="'timing-panel-body-wrapper timing-panel-scroll'"
      [disablePin]="isMobile() || false"
      [ngClass]="timingPanel.isPinned() && timingPanel.isOpen() ? 'grow-1' : ''"
    >
      <div header>
        <div class="flex gap-2 font-semibold">
          <span class="text-xl">Race Standings</span>
          <button class="header-btn" (click)="openFullTimingPage()" target="_blank">
            <svg fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
              <path
                d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6M15 3h6v6M10 14L21 3"
              ></path>
            </svg>
          </button>
        </div>
        <div class="flex justify-inherit gap-2 my-2 font-semibold">
          <span>Race Feed: </span>
          <vb-lxp-checkbox
            [(checked)]="streamService.isMainStreamSelected"
            (checkedChange)="onMainStreamToggled($event)"
            >Main Stream</vb-lxp-checkbox
          >
          <vb-lxp-checkbox
            [(checked)]="streamService.isTwitchStreamSelected"
            (checkedChange)="onTwitchStreamToggled($event)"
            >Twitch Stream</vb-lxp-checkbox
          >
        </div>
        <div class="flex items-center">
          <vb-lxp-switch [(checked)]="moreColumns" [leftLabel]="'More Info'"></vb-lxp-switch>
          <app-race-class
            class="absolute right-2"
            [classes]="raceSessionService.raceClasses$ | async"
            (selectionChange)="selectedClasses.set($event)"
          ></app-race-class>
        </div>
      </div>
      <div body>
        <vb-lxp-timing-tower
          class="w-full"
          [enableMoreColumns]="moreColumns()"
          [selectedClasses]="selectedClasses()"
          [activeClass]="'active-tower-item'"
          [activeNumberClass]="'text-secondary'"
          (selectionAdded)="onTimingTowerSelectionAdded($event)"
          (selectionRemoved)="onTimingTowerSelectionRemoved($event)"
        ></vb-lxp-timing-tower>
      </div>
    </vb-lxp-panel>
    <vb-lxp-panel
      #chatPanel
      [panelKey]="'chat'"
      [panelClass]="'chat-panel'"
      [panelHeaderClass]="'chat-panel-header'"
      [panelBodyClass]="'chat-panel-body-wrapper px-1'"
      [disablePin]="isMobile()!"
      [ngClass]="chatPanel.isPinned() && chatPanel.isOpen() ? 'chat-panel-pinned grow-1' : ''"
    >
      <div header class="chat-header-content">
        <span>SRO Stream Chat</span>
      </div>
      <div body>
        <app-twitch-chat></app-twitch-chat>
      </div>
    </vb-lxp-panel>
  </div>
</div>
